import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useToast } from '../common/Toast';
import { useI18n } from '../../i18n/I18nContext';
import './AuthPages.css';

function RegisterPage() {
  const { t } = useI18n();
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    password: '',
    confirmPassword: '',
    telephone: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const addToast = useToast();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError(t.auth.pwdNoMatch);
      return;
    }

    if (formData.password.length < 8) {
      setError(t.auth.pwdTooShort);
      return;
    }

    setLoading(true);
    try {
      await register({
        nom: formData.nom,
        prenom: formData.prenom,
        email: formData.email,
        password: formData.password,
        telephone: formData.telephone
      });
      addToast(t.auth.regSuccess);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card glass-card">
        <h2>{t.auth.registerTitle}</h2>
        <p className="auth-subtitle">{t.auth.registerSubtitle}</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>{t.auth.lastName}</label>
              <input type="text" name="nom" value={formData.nom} onChange={handleChange} placeholder="Benali" required />
            </div>
            <div className="form-group">
              <label>{t.auth.firstName}</label>
              <input type="text" name="prenom" value={formData.prenom} onChange={handleChange} placeholder="Mohamed" required />
            </div>
          </div>

          <div className="form-group">
            <label>{t.auth.email}</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="votre@email.com" required />
          </div>

          <div className="form-group">
            <label>{t.auth.phone}</label>
            <input type="tel" name="telephone" value={formData.telephone} onChange={handleChange} placeholder="0555123456" />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>{t.auth.password}</label>
              <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Min. 6" required />
            </div>
            <div className="form-group">
              <label>{t.auth.confirmPwd}</label>
              <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="••••••" required />
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? t.auth.registerLoading : t.auth.registerBtn}
          </button>
        </form>

        <p className="auth-footer">
          {t.auth.haveAccount} <Link to="/login">{t.auth.connect}</Link>
        </p>
      </div>
    </div>
  );
}

export default RegisterPage;
